import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    paddingTop: 1,
    paddingBottom: 0,
    color: '#d63031',
  },
}));
